'use client';

import { Button, Icon, Input, InputWrapper, Logo } from '../../components';
import { Paper } from '../../layout';
import type { FieldDefinition, LinkItem } from '../../types';
import React, { useState } from 'react';

export interface ForgotPasswordProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  buttonTitle: string;
  loginLink?: LinkItem;
  links?: boolean;
  emailField: Pick<FieldDefinition, 'label' | 'placeholder'>;
  onSubmit?: (email: string) => void;
}

export function ForgotPassword(props: ForgotPasswordProps) {
  const { title, description, loginLink, buttonTitle, emailField, links = false } = props;
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (props.onSubmit) {
      props.onSubmit(email);
    } else {
      // eslint-disable-next-line no-console
      console.warn('onSubmit handler is not provided');
    }
  };

  return (
    <div className='flex flex-col items-center gap-xl w-full max-w-md px-md sm:px-0'>
      <Logo className='h-10'></Logo>
      <Paper className='flex flex-col items-center gap-sm shadow-lg border border-border-base rounded-xl w-full p-lg sm:p-xl'>
        <Paper.Title>{title}</Paper.Title>
        {description && (
          <p className='text-foreground-muted text-center text-sm mb-sm'>{description}</p>
        )}
        <Paper.Content className='w-full flex flex-col items-center gap-md'>
          <form className='w-full flex flex-col gap-md' onSubmit={handleSubmit} noValidate={false}>
            <InputWrapper className='w-full' label={emailField.label} required>
              <Input
                leftContent={<Icon name='envelope-open-text'></Icon>}
                className='bg-background-input'
                placeholder={emailField.placeholder}
                required
                name='email'
                type='email'
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </InputWrapper>

            <Button type='submit' size='full' className='self-center px-md w-full! mt-lg'>
              {buttonTitle}
            </Button>
          </form>
          {links && loginLink && (
            <footer className='flex justify-center gap-md'>
              <a
                href={loginLink.href}
                className='text-primary-base hover:text-primary-hover flex items-center gap-xs'
              >
                <Icon name='chevron-down' rotate={90} className='text-primary-base' />
                {loginLink.label}
              </a>
            </footer>
          )}
        </Paper.Content>
      </Paper>
    </div>
  );
}
